"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLinkToolbarButtonState = exports.useLinkToolbarButton = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateLink = require("@udecode/plate-link");
var useLinkToolbarButtonState = function useLinkToolbarButtonState() {
  var pressed = (0, _plateCommon.useEditorSelector)(function (editor) {
    return !!(editor !== null && editor !== void 0 && editor.selection) && (0, _plateCommon.someNode)(editor, {
      match: {
        type: (0, _plateCommon.getPluginType)(editor, _plateLink.ELEMENT_LINK)
      }
    });
  }, []);
  return {
    pressed: pressed
  };
};
exports.useLinkToolbarButtonState = useLinkToolbarButtonState;
var useLinkToolbarButton = function useLinkToolbarButton(state) {
  var editor = (0, _plateCommon.useEditorRef)();
  return {
    props: {
      onClick: function onClick() {
        (0, _plateLink.triggerFloatingLink)(editor, {
          focused: true
        });
      },
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
      },
      pressed: state.pressed
    }
  };
};
exports.useLinkToolbarButton = useLinkToolbarButton;